const parseAddress = (address) => {
    let parsedAddress = {};

    address.address_components.map((item) => {
        if (item.types[0]) {
            let type = item.types[0];

            if (type === 'postal_code') {
                type = 'postalCode';
            } else if (type === 'postal_town') {
                type = 'city';
            }

            parsedAddress[type] = item.long_name;
        }
    });

    const streetNumber =
        parsedAddress.subpremise || parsedAddress.street_number || '';
    const streetName = parsedAddress.premise || parsedAddress.route || '';

    let street = '';

    if (streetNumber !== '') {
        street += `${streetNumber} `;
    }

    street += streetName;

    parsedAddress.street = street;

    return parsedAddress;
};

export { parseAddress };
